import React from "react";

import { Text } from "@ui/Atoms/Text";

import { useTranslate } from "@hooks/useTranslate";

interface Props {
  className?: string;
}

export const Title: React.FC<Props> = ({ className }) => {
  const translate = useTranslate("batmaid_pwa_static_homepage");

  return (
    <Text
      className={className}
      as="h1"
      $style={{
        default: "bold_40",
        smallTablet: "bold_64",
        smallDesktop: "bold_80",
      }}
      $color="white"
      $breakWord
    >
      {translate("hero_heading")}
    </Text>
  );
};
